import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { FlagsProvider } from '@atlaskit/flag';
import { fg } from '@atlaskit/platform-feature-flags';
import { Logger } from '../../common/utils/logger';
import { ConsentBannerImpl } from './consent-banner-impl';
export var ConsentBanner = function ConsentBanner(props) {
  if (fg('platform_moonjelly_bsc_master_killswitch') || fg('platform_moonjelly_bsc_ui_killswitch')) {
    // Don't render the consent banner if the killswitch is enabled
    return null;
  }
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    FallbackComponent: function FallbackComponent() {
      return /*#__PURE__*/React.createElement("div", {
        "data-testid": "consent-banner-render-error"
      });
    },
    onError: function onError(e) {
      Logger.errorWithOperationalEvent({
        action: 'renderConsentBannerError',
        message: e.message || ''
      });
    }
  }, /*#__PURE__*/React.createElement(FlagsProvider, null, /*#__PURE__*/React.createElement(ConsentBannerImpl, props)));
};